export interface EditProductOfferings {
    productOfferingId: ProductOfferingId,
    decommissionDate: Date,
    dateStrategyAssignments: DateStrategyAssignment[],
    id: EntityId
}

export interface ProductOfferingId {
    schoolId: SchoolId,
    productId: ProductId,
    rawSchoolId: number,
    rawProductId: number,
    rawProductTypeId: number
}

export interface SchoolIdObject {
    id?: number | string;
    code?: string;
}

export type SchoolId = SchoolIdObject | string | number;

export interface ProductId {
    id: number,
    type: ProductType
}

export interface ProductType {
    id: number,
    name: string
}

export interface DateStrategyAssignment {
    strategyTypeId: number,
    fromDate: Date,
    toDate: Date,
    recurranceStartDays: IsoDayOfWeek[]
    specificStartDates: Date[]
    fixedDurationDates: FixedDurationDates[]
}

export interface FixedDurationDates {
    startDate: Date,
    endDate: Date
}

export enum IsoDayOfWeek {
    None = 0,
    Monday = 1,
    Tuesday = 2,
    Wednesday = 3,
    Thursday = 4,
    Friday = 5,
    Saturday = 6,
    Sunday = 7,
}

export interface EntityId {
    id: number,
    entityTypeId: number
}

export enum DateStrategy {
    'Recurrence' = 1,
    'Fixed Duration' = 2,
    'Offering Dates' = 3,
    'Specific Start Dates' = 4
}

export enum BandStrategy {
    'Discrete' = 1,
    'Compound' = 2
}